(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-announcement"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-announcement]').forEach((bar) => {
    const items = Array.from(bar.querySelectorAll('[data-tn-announcement-item]'));
    const delay = Number(bar.dataset.delay) || 5000;
    let index = 0;
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.setInterval(() => {
      index = (index + 1) % items.length;
      items.forEach((item, itemIndex) => {
        item.dataset.active = String(itemIndex === index);
      });
    }, delay);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-blog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-blog-slider]').forEach((section) => {
    if (section.dataset.tnSliderReady === 'true') return;
    section.dataset.tnSliderReady = 'true';
    const track = section.querySelector('[data-tn-blog-track]');
    if (!track) return;
    section.querySelector('[data-tn-blog-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .88, behavior: 'smooth' }));
    section.querySelector('[data-tn-blog-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .88, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-collection-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-category-filter]').forEach((filter) => {
    const toggle = filter.querySelector('[data-tn-category-toggle]');
    toggle?.addEventListener('click', () => {
      const open = filter.getAttribute('data-open') === 'true';
      filter.setAttribute('data-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  document.querySelectorAll('[data-tn-collection-mini]').forEach((section) => {
    const track = section.querySelector('[data-tn-mini-track]');
    section.querySelector('[data-tn-mini-prev]')?.addEventListener('click', () => {
      track?.scrollBy({ left: -(track.clientWidth * 0.85), behavior: 'smooth' });
    });
    section.querySelector('[data-tn-mini-next]')?.addEventListener('click', () => {
      track?.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-collections"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-collections-slider]').forEach((section) => {
    if (section.dataset.tnSliderReady === 'true') return;
    section.dataset.tnSliderReady = 'true';
    const track = section.querySelector('[data-tn-collections-track]');
    if (!track) return;
    section.querySelector('[data-tn-collections-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .88, behavior: 'smooth' }));
    section.querySelector('[data-tn-collections-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .88, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-compact-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-scroll-section]').forEach((section) => {
    const track = section.querySelector('[data-tn-scroll-track]');
    const previous = section.querySelector('[data-tn-scroll-prev]');
    const next = section.querySelector('[data-tn-scroll-next]');
    if (!track) return;
    previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-favorites"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-favorites-page]').forEach((page) => {
    const grid = page.querySelector('[data-tn-favorites-grid]');
    const empty = page.querySelector('[data-tn-favorites-empty]');
    const readFavorites = () => {
      try {
        return JSON.parse(localStorage.getItem('tablonow-favorites') || '[]');
      } catch {
        return [];
      }
    };

    const render = () => {
      const favorites = readFavorites();
      grid.replaceChildren();
      empty.hidden = favorites.length > 0;
      grid.hidden = favorites.length === 0;

      favorites.forEach((favorite) => {
        const article = document.createElement('article');
        article.className = 'tn-favorite-card';

        const media = document.createElement('a');
        media.className = 'tn-favorite-card__media';
        media.href = favorite.url;
        if (favorite.image) {
          const image = document.createElement('img');
          image.src = favorite.image;
          image.alt = favorite.title;
          image.loading = 'lazy';
          media.append(image);
        }

        const remove = document.createElement('button');
        remove.className = 'tn-favorite-card__remove';
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', `${page.dataset.removeText}: ${favorite.title}`);
        remove.addEventListener('click', () => {
          const nextFavorites = readFavorites().filter((item) => item.handle !== favorite.handle);
          localStorage.setItem('tablonow-favorites', JSON.stringify(nextFavorites));
          window.dispatchEvent(new CustomEvent('tablonow:favorites-changed'));
          render();
        });

        const heading = document.createElement('h2');
        const link = document.createElement('a');
        link.href = favorite.url;
        link.textContent = favorite.title;
        heading.append(link);

        const price = document.createElement('strong');
        price.textContent = favorite.price;

        article.append(media, remove, heading, price);
        grid.append(article);
      });
    };

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-gallery-section]').forEach((section) => {
    const track = section.querySelector('[data-tn-gallery-track]');
    const previous = section.querySelector('[data-tn-gallery-prev]');
    const next = section.querySelector('[data-tn-gallery-next]');
    if (!track) return;
    previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-header"] && !Shopify.designMode) return;
  try {
    
  const updateTablonowFavoriteCounts = () => {
    let favorites = [];
    try {
      favorites = JSON.parse(localStorage.getItem('tablonow-favorites') || '[]');
    } catch {
      favorites = [];
    }
    document.querySelectorAll('[data-tn-favorite-count]').forEach((count) => {
      count.textContent = String(favorites.length);
    });
  };
  updateTablonowFavoriteCounts();
  window.addEventListener('tablonow:favorites-changed', updateTablonowFavoriteCounts);

  const readTablonowFavorites = () => {
    try {
      return JSON.parse(localStorage.getItem('tablonow-favorites') || '[]');
    } catch {
      return [];
    }
  };

  const syncTablonowFavoriteButtons = () => {
    const favorites = readTablonowFavorites();
    document.querySelectorAll('[data-tn-card-favorite]').forEach((button) => {
      button.setAttribute('aria-pressed', String(favorites.some((item) => item.handle === button.dataset.handle)));
    });
  };

  const initializeTablonowFavoriteCards = () => {
    updateTablonowFavoriteCounts();
    syncTablonowFavoriteButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTablonowFavoriteCards, { once: true });
  } else {
    initializeTablonowFavoriteCards();
  }

  if (!window.tablonowFavoriteCardsBound) {
    window.tablonowFavoriteCardsBound = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tn-card-favorite]');
      if (!button) return;

      const favorites = readTablonowFavorites();
      const index = favorites.findIndex((item) => item.handle === button.dataset.handle);
      if (index >= 0) {
        favorites.splice(index, 1);
      } else {
        favorites.push({
          handle: button.dataset.handle,
          title: button.dataset.title,
          url: button.dataset.url,
          image: button.dataset.image,
          price: button.dataset.price
        });
      }
      localStorage.setItem('tablonow-favorites', JSON.stringify(favorites));
      syncTablonowFavoriteButtons();
      updateTablonowFavoriteCounts();
      window.dispatchEvent(new CustomEvent('tablonow:favorites-changed'));
    });
  }

  document.querySelectorAll('[data-tn-mobile-menu]').forEach((menu) => {
    const menuId = menu.id;
    const opener = document.querySelector(`[aria-controls="${menuId}"]`);
    const closeButtons = menu.querySelectorAll('[data-tn-menu-close]');
    const panel = menu.querySelector('.tn-mobile-menu__panel');

    menu.querySelectorAll('[data-tn-submenu-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-tn-mobile-group]');
        const submenu = group?.querySelector('[data-tn-mobile-submenu]');
        const willOpen = group?.dataset.open !== 'true';
        if (!group || !submenu) return;
        group.dataset.open = willOpen ? 'true' : 'false';
        submenu.hidden = !willOpen;
        button.setAttribute('aria-expanded', String(willOpen));
      });
    });

    const closeMenu = () => {
      menu.hidden = true;
      document.documentElement.classList.remove('tn-menu-open');
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    };

    const openMenu = () => {
      menu.hidden = false;
      document.documentElement.classList.add('tn-menu-open');
      opener?.setAttribute('aria-expanded', 'true');
      menu.querySelector('[data-tn-menu-close]:not(.tn-mobile-menu__backdrop)')?.focus();
    };

    opener?.addEventListener('click', openMenu);
    closeButtons.forEach((button) => button.addEventListener('click', closeMenu));
    panel?.addEventListener('click', (event) => event.stopPropagation());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) closeMenu();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-home-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-banner]').forEach((banner) => {
    const slides = Array.from(banner.querySelectorAll('[data-tn-banner-slide]'));
    const dots = Array.from(banner.querySelectorAll('[data-tn-banner-dot]'));
    const delay = Number(banner.dataset.autoplay) || 5000;
    let index = 0;
    let timer;
    let touchStartX = 0;

    const show = (target) => {
      index = (target + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.dataset.active = String(slideIndex === index);
      });
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', String(dotIndex === index));
      });
    };

    const start = () => {
      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      clearInterval(timer);
      timer = setInterval(() => show(index + 1), delay);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.tnBannerDot));
        start();
      });
    });
    banner.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].clientX;
        clearInterval(timer);
      },
      { passive: true }
    );
    banner.addEventListener(
      'touchend',
      (event) => {
        const difference = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(difference) > 45) show(index + (difference < 0 ? 1 : -1));
        start();
      },
      { passive: true }
    );
    banner.addEventListener('mouseenter', () => clearInterval(timer));
    banner.addEventListener('mouseleave', start);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-loveflix-personalizer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tablonow-personalizer')) {
    customElements.define(
      'tablonow-personalizer',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.variantInput = this.querySelector('[data-variant-id]');
          this.frame = this.querySelector('[data-frame]');
          this.poster = this.querySelector('[data-poster]');
          this.photoInput = this.querySelector('[data-photo-input]');
          this.photoFileName = this.querySelector('[data-photo-file-name]');
          this.photoPreview = this.querySelector('[data-preview-photo]');
          this.photoHint = this.querySelector('[data-photo-hint]');
          this.nameInputs = [...this.querySelectorAll('[data-preview-name]')];
          this.optionInputs = [...this.querySelectorAll('[data-option-index] input')];
          this.optionInputs.forEach((input) => input.addEventListener('change', () => this.updateVariant()));
          this.nameInputs.forEach((input) => input.addEventListener('input', () => this.updateNames()));
          this.updateNames();
          this.querySelectorAll('[data-preview-input]').forEach((input) => {
            input.addEventListener('input', () => this.updateText(input));
            this.updateText(input);
          });
          this.photoInput.addEventListener('change', () => this.updatePhoto());
          this.updateVariant();
        }

        updateText(input) {
          const target = this.querySelector(`[data-preview-${input.dataset.previewInput}]`);
          if (target) target.textContent = input.value.trim() || input.dataset.previewFallback || '';
        }

        updateNames() {
          const target = this.querySelector('[data-preview-names]');
          if (!target) return;
          const names = this.nameInputs.map((input) => {
            return input.value.trim() || input.dataset.previewFallback || '';
          });
          target.textContent = names.filter(Boolean).join(' & ');
        }

        updatePhoto() {
          const file = this.photoInput.files[0];
          const summary = this.querySelector('[data-summary-photo]');
          if (!file) {
            if (summary) summary.textContent = 'Henüz seçilmedi';
            if (this.photoFileName) this.photoFileName.textContent = this.dataset.uploadEmptyLabel;
            return;
          }
          if (summary) summary.textContent = file.name;
          if (this.photoFileName) this.photoFileName.textContent = file.name;
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            this.photoPreview.src = reader.result;
            this.photoHint.hidden = true;
          });
          reader.readAsDataURL(file);
        }

        updateVariant() {
          const selected = [...this.querySelectorAll('[data-option-index]')].map((group) => {
            return group.querySelector('input:checked')?.value;
          });
          const variant = this.variants.find((item) => {
            return item.options.every((option, index) => option === selected[index]);
          });
          const design = selected.find((value) => /loveflix|friendflix|momflix|familyflix/i.test(value || ''));
          const color = selected.find((value) => /beyaz|siyah|ahşap|ahsap/i.test(value || ''));
          if (design) {
            this.querySelector('[data-preview-theme]').textContent = design.toLocaleUpperCase('tr-TR');
            this.poster.dataset.design = design.toLocaleLowerCase('tr-TR');
          }
          if (color) this.frame.dataset.color = color.toLocaleLowerCase('tr-TR');
          selected.forEach((value, index) => {
            const summary = this.querySelector(`[data-summary-option="${index}"]`);
            if (summary) summary.textContent = value || 'Seçilmedi';
          });
          if (!variant) return;
          this.variantInput.value = variant.id;
          this.querySelector('[data-price]').textContent = this.formatMoney(variant.price);
          this.querySelector('[data-button-price]').textContent = this.formatMoney(variant.price);
          const compare = this.querySelector('[data-compare-price]');
          const discount = this.querySelector('[data-discount]');
          compare.hidden = !(variant.compare_at_price > variant.price);
          discount.hidden = compare.hidden;
          if (!compare.hidden) compare.textContent = this.formatMoney(variant.compare_at_price);
          const submit = this.querySelector('.tn-personalizer__submit');
          const submitText = this.querySelector('[data-submit-text]');
          submit.disabled = !variant.available;
          submitText.textContent = variant.available ? this.dataset.buttonLabel : this.dataset.soldOutLabel;
        }

        formatMoney(cents) {
          const amount = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(cents / 100);
          return `${amount} TL`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-products-slider]').forEach((section) => {
    if (section.dataset.tnSliderReady === 'true') return;
    section.dataset.tnSliderReady = 'true';

    const track = section.querySelector('[data-tn-products-track]');
    const previous = section.querySelector('[data-tn-products-prev]');
    const next = section.querySelector('[data-tn-products-next]');
    if (!track) return;

    previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.86, behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.86, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-product-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-product-root]').forEach((root) => {
    const gallery = root.querySelector('[data-tn-product-gallery]');
    const slides = Array.from(root.querySelectorAll('[data-tn-product-media]'));
    const thumbs = Array.from(root.querySelectorAll('[data-tn-product-thumb]'));
    const counter = root.querySelector('[data-tn-product-current]');
    let mediaIndex = 0;
    let touchStartX = 0;

    const showMedia = (target) => {
      if (!slides.length) return;
      mediaIndex = (target + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        slide.dataset.active = String(index === mediaIndex);
      });
      thumbs.forEach((thumb, index) => {
        thumb.setAttribute('aria-current', String(index === mediaIndex));
      });
      if (counter) counter.textContent = String(mediaIndex + 1);
    };

    root.querySelector('[data-tn-product-prev]')?.addEventListener('click', () => showMedia(mediaIndex - 1));
    root.querySelector('[data-tn-product-next]')?.addEventListener('click', () => showMedia(mediaIndex + 1));
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.tnProductThumb)));
    });
    gallery?.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );
    gallery?.addEventListener(
      'touchend',
      (event) => {
        const difference = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(difference) > 45) showMedia(mediaIndex + (difference < 0 ? 1 : -1));
      },
      { passive: true }
    );

    const favoriteButton = root.querySelector('[data-tn-favorite-button]');
    const readFavorites = () => {
      try {
        return JSON.parse(localStorage.getItem('tablonow-favorites') || '[]');
      } catch {
        return [];
      }
    };
    const syncFavorite = () => {
      const favorites = readFavorites();
      favoriteButton?.setAttribute(
        'aria-pressed',
        String(favorites.some((favorite) => favorite.handle === favoriteButton.dataset.handle))
      );
    };
    favoriteButton?.addEventListener('click', () => {
      const favorites = readFavorites();
      const existingIndex = favorites.findIndex((favorite) => favorite.handle === favoriteButton.dataset.handle);
      if (existingIndex >= 0) {
        favorites.splice(existingIndex, 1);
      } else {
        favorites.push({
          handle: favoriteButton.dataset.handle,
          title: favoriteButton.dataset.title,
          url: favoriteButton.dataset.url,
          image: favoriteButton.dataset.image,
          price: favoriteButton.dataset.price
        });
      }
      localStorage.setItem('tablonow-favorites', JSON.stringify(favorites));
      syncFavorite();
      window.dispatchEvent(new CustomEvent('tablonow:favorites-changed'));
    });
    syncFavorite();

    const variantData = root.querySelector('[data-tn-product-variants]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const variantInput = root.querySelector('[data-tn-variant-id]');
    const addButton = root.querySelector('[data-tn-add-button]');
    const currentPrice = root.querySelector('[data-tn-current-price]');
    const comparePrice = root.querySelector('[data-tn-compare-price]');
    const discountBadge = root.querySelector('[data-tn-discount-badge]');
    const formatMoney = (cents) => {
      return `${new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(cents / 100)} TL`;
    };

    const updateVariant = () => {
      const selections = Array.from(root.querySelectorAll('[data-tn-option-group]')).map((group) => {
        return group.querySelector('input:checked')?.value;
      });
      if (!selections.length) return;
      const variant = variants.find((item) => item.options.every((option, index) => option === selections[index]));
      if (!variant) {
        if (addButton) addButton.disabled = true;
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (currentPrice) currentPrice.textContent = formatMoney(variant.price);
      if (comparePrice) {
        comparePrice.hidden = !(variant.compare_at_price > variant.price);
        comparePrice.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
      }
      if (discountBadge) {
        const percentage = variant.compare_at_price > variant.price
          ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
          : 0;
        discountBadge.hidden = percentage === 0;
        discountBadge.textContent = `%${percentage} İNDİRİM`;
      }
      if (addButton) addButton.disabled = !variant.available;
      selections.forEach((selection, index) => {
        const summaryValue = root.querySelector(`[data-tn-summary-option="${index + 1}"]`);
        if (summaryValue) summaryValue.textContent = selection || 'Seçilmedi';
      });
    };
    root.querySelectorAll('[data-tn-option-group] input').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    const uploadInputs = Array.from(root.querySelectorAll('[data-tn-upload-input]'));
    const photoProgressGroups = Array.from(root.querySelectorAll('[data-tn-photo-progress]'));
    const summaryPhotoRow = root.querySelector('[data-tn-summary-photos]');
    const summaryPhotoSelected = root.querySelector('[data-tn-summary-photo-selected]');
    const summaryPhotoRequired = root.querySelector('[data-tn-summary-photo-required]');

    const updatePhotoProgress = () => {
      const selectedTotal = uploadInputs.filter((input) => input.files?.length).length;
      const requiredTotal = uploadInputs.filter((input) => input.required).length;

      photoProgressGroups.forEach((progress) => {
        const group = progress.closest('.tn-personalization-group--photos');
        const groupInputs = Array.from(group?.querySelectorAll('[data-tn-upload-input]') || []);
        const selected = groupInputs.filter((input) => input.files?.length).length;
        const required = Number(progress.dataset.requiredPhotoCount || groupInputs.length);
        const selectedText = progress.querySelector('[data-tn-photo-selected]');
        const bar = progress.querySelector('[data-tn-photo-progress-bar]');

        if (selectedText) selectedText.textContent = String(selected);
        if (bar) bar.value = selected;
      });

      if (summaryPhotoRow) summaryPhotoRow.hidden = requiredTotal === 0;
      if (summaryPhotoSelected) summaryPhotoSelected.textContent = String(selectedTotal);
      if (summaryPhotoRequired) summaryPhotoRequired.textContent = String(requiredTotal);
    };

    uploadInputs.forEach((input) => {
      let previewUrl;
      input.addEventListener('change', () => {
        const field = input.closest('[data-tn-upload-field]');
        const image = field?.querySelector('[data-tn-upload-image]');
        const status = field?.querySelector('[data-tn-upload-status]');
        const preview = field?.querySelector('[data-tn-upload-preview]');
        const file = input.files?.[0];

        if (previewUrl) {
          URL.revokeObjectURL(previewUrl);
          previewUrl = undefined;
        }

        if (!file) {
          if (image) {
            image.hidden = true;
            image.removeAttribute('src');
          }
          if (status) status.textContent = 'Henüz fotoğraf seçilmedi';
          if (preview) {
            delete preview.dataset.quality;
            preview.hidden = true;
          }
          updatePhotoProgress();
          return;
        }

        if (status) status.textContent = file.name;
        if (preview) preview.hidden = false;
        if (image) {
          previewUrl = URL.createObjectURL(file);
          image.src = previewUrl;
          image.hidden = false;
        }

        const qualityImage = new Image();
        qualityImage.addEventListener('load', () => {
          const shortestSide = Math.min(qualityImage.naturalWidth, qualityImage.naturalHeight);
          if (preview) preview.dataset.quality = shortestSide < 800 ? 'low' : 'good';
          if (status && shortestSide < 800) {
            status.textContent = `${file.name} · çözünürlük düşük olabilir`;
          }
        });
        qualityImage.src = previewUrl;
        updatePhotoProgress();
      });
    });
    updatePhotoProgress();

    root.querySelectorAll('[data-tn-countdown]').forEach((countdown) => {
      const end = new Date(countdown.dataset.end).getTime();
      if (!Number.isFinite(end)) {
        countdown.hidden = true;
        return;
      }
      const render = () => {
        const remaining = end - Date.now();
        if (remaining <= 0) {
          countdown.hidden = true;
          return false;
        }
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        countdown.querySelector('[data-tn-days]').textContent = String(days).padStart(2, '0');
        countdown.querySelector('[data-tn-hours]').textContent = String(hours).padStart(2, '0');
        countdown.querySelector('[data-tn-minutes]').textContent = String(minutes).padStart(2, '0');
        countdown.querySelector('[data-tn-seconds]').textContent = String(seconds).padStart(2, '0');
        return true;
      };
      if (render()) window.setInterval(render, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-review-section]').forEach((section) => {
    const track = section.querySelector('[data-tn-review-track]');
    const previous = section.querySelector('[data-tn-review-prev]');
    const next = section.querySelector('[data-tn-review-next]');
    if (!track) return;
    previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-tracking-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-tracking]').forEach((section) => {
    const form = section.querySelector('[data-tn-tracking-form]');
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const order = String(data.get('order_number') || '').trim();
      const email = String(data.get('email') || '').trim();
      const base = section.dataset.whatsapp?.split('?')[0];
      if (!base || !order || !email) return;
      const message = `Merhaba Tablonow, ${order} numaralı siparişimin kargo durumunu öğrenmek istiyorum. Sipariş e-postam: ${email}`;
      window.open(`${base}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablonow-videos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tn-video-section]').forEach((section) => {
    const track = section.querySelector('[data-tn-video-track]');
    const previous = section.querySelector('[data-tn-video-prev]');
    const next = section.querySelector('[data-tn-video-next]');
    if (!track) return;
    previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();
})();
